<template>
    <div class="jump-cart">
        <van-nav-bar title="订单信息" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">

        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, List} from "vant";

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {};
        }, mounted: function () {

        },
        methods: {
            back() {
                history.back();
            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

